import { autocompleteClasses, Popper, styled } from '@mui/material'

export const AutocompletePopper = styled(Popper)(({ theme }) => ({
  [`& .${autocompleteClasses.paper}`]: {
    borderRadius: '4px',
    outline: `1px solid ${theme.palette.carribeanGreen}`,

    border: 'none',
    backgroundColor: theme.palette.alabaster,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,

    '&:empty': {
      border: 'none',
    },
  },

  [`& .${autocompleteClasses.listbox}`]: {
    padding: 0,
    maxHeight: theme.spacing(26.5),
  },

  [`& .${autocompleteClasses.noOptions}`]: {
    ...theme.typography.caption1,
  },
}))
